import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';

const Date = React.forwardRef(function Date({ date }, ref) {
  return <p className={'w-modal__date'}>{safeHTML(date)}</p>;
});
export default Date;
Date.propTypes = {};
